module.exports = __webpack_public_path__ + "img/dstv.a25123ae.svg";